import React, { Fragment } from 'react';

const ContactUs = () => (
  <Fragment>
    <p>
      Our customer care team is here for you 24/7! Open the Autzu app,
      navigate to the "Support" section at the bottom of the screen, and
      submit a support ticket. We'll be in touch promptly to help answer
      any questions you may have.
    </p>
  </Fragment>
);

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ContactUs/index.js